/** @jsx jsx */
import { jsx } from '@emotion/react'
import { css } from '@emotion/react/macro'

const modalFooterCss = css`
  grid-column: 1 / 3;
  grid-row: 3 / 3;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`
const lastItemCss = css`
  margin-left: auto;
`

type ModalFooterProps = {
  children: React.ReactNode
  /** Element to display at the start of the footer */
  startElement?: React.ReactNode
}

const defaultProps: Pick<ModalFooterProps, 'startElement'> = {
  startElement: undefined
}

const ModalFooter = ({ children, startElement }: ModalFooterProps) => (
  <div css={modalFooterCss}>
    {startElement && <div>{startElement}</div>}
    <div css={lastItemCss}>{children}</div>
  </div>
)

ModalFooter.defaultProps = defaultProps

export default ModalFooter
